import { render, staticRenderFns } from "./prop1.vue?vue&type=template&id=8e1568c4&scoped=true&"
import script from "./prop1.vue?vue&type=script&lang=js&"
export * from "./prop1.vue?vue&type=script&lang=js&"
import style0 from "./prop1.vue?vue&type=style&index=0&id=8e1568c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../blsguanfang_blszf/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1568c4",
  null
  
)

export default component.exports